<template>
    <div class="spark-screen container">
        <div class="row">
            <div class="col-md-3 spark-settings-tabs">
                <aside>
                    <h3 class="nav-heading ">
                        <b-button-group size="sm">
                            <b-button
                                :variant="currentTab === 'sales_behaviors' ?  'primary' : 'secondary' "
                                @click="changeTab('sales_behaviors')"
                            >
                                Sales Activities
                            </b-button>
                            <b-button
                                :variant="currentTab === 'sales_statuses' ?  'primary' : 'secondary' "
                                @click="changeTab('sales_statuses')"
                            >
                                Sales Status
                            </b-button>
                        </b-button-group>
                    </h3>
                    <ul class="nav flex-column mb-4 " v-if="currentTab === 'sales_behaviors'">
                        <span v-if="isBehaviorsLoading" class="text-5xl text-grey-darkest ml-5 mt-32">
                                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                        </span>

                        <span v-else v-for="(item, index) in salesBehaviorsProjectsList">
                            <li  :key="index" class="nav-item">
                                <a :class="(selectedSalesBehavior && item.id === selectedSalesBehavior.id)? 'nav-link active saleBehaviorTabListAnchor':'nav-link saleBehaviorTabListAnchor'+' customTabs-'+index"
                                    :href="'#sl-' + item.id"
                                    :aria-controls="item.name"
                                    @click="changeContactActivitiesTab(null);removeActiveContactActivity();selectSalesBehavior(item)">
                                    <div class="red-indicator mr-2 mt-1 text-white text-center">
                                        {{ item.data.late }}
                                    </div>
                                    {{ item.name }}
                                </a>
                            </li>
                        </span>
                    </ul>
                    <ul class="nav flex-column mb-4 " v-if="currentTab === 'sales_statuses'">
                        <span v-if="isSalesStatusLoading" class="text-5xl text-grey-darkest ml-5 mt-32">
                                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                        </span>
                        <span v-else>
                            <li class="nav-item hover:bg-grey-lighter cursor-pointer p-2 flex h-10" @click="fetchProjects({id:0, code: 'All'});changeContactActivitiesTab(null)">
                                <div class="float-left saleStatusTabListAnchor" :class="{'text-primary':selectedSalesStatus.id === 0}">
                                    All
                                </div>
                            </li>

                             <li v-for="(item, index) in salesStatusesList" :key="index" class="nav-item hover:bg-grey-lighter cursor-pointer p-2 mt-2 flex h-10" @click="fetchProjects(item, 1);changeContactActivitiesTab(null);removeActiveContactActivity()">
                                 <div class="block h-4 w-4 shadow-solid mt-1 mr-2" :style="{backgroundColor: `${item.color}`}"></div>
                                 <div class="black-indicator mr-2 text-white text-center float-left bg-black">
                                     {{ item.sum_projects }}
                                 </div>
                                 <div class="float-left nav-link text-center mt-1 saleStatusTabListAnchor" :class="{'text-primary':selectedSalesStatus.id === item.id}">
                                     {{ item.code }} {{ ` - ${(item.sum_base_bid ? item.sum_base_bid/100 : 0).toLocaleString('en-US',
                                 {style: 'currency', currency: 'USD'})}` }}
                                 </div>
                            </li>
                        </span>
                    </ul>

                    <h2 class="nav-heading">
                        Contact Activities
                    </h2>

                    <ul class="nav flex-column mb-4 ">
                        <span v-if="isContactBehaviorsLoading" class="text-5xl text-grey-darkest ml-5 mt-32">
                                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                        </span>
                        <span v-else>

                            <li v-for="(item, index) in salesBehaviorsContactsList" :key="index" class="nav-item hover:bg-grey-lighter cursor-pointer mt-2 flex h-10" ref="contactActivitiesList" @click="changeContactActivitiesTab(item);setActiveContactActivity(index)">
                                <div>
                                    <div class="red-indicator mr-2 mt-2 text-white text-center float-left bg-black">
                                        {{ item.data.late }}
                                    </div>
                                    <div class="float-left nav-link text-center mt-1" :class="{ 'active': contactActivityActiveIndex === index }">
                                        {{item.name}}
                                    </div>
                                </div>
                            </li>
                        </span>

                    </ul>

                </aside>
            </div>

            <div class="col-md-9" v-if="currentTab === 'sales_behaviors' && contactSaleBehaviorCurrentItem === null">
                <div v-if="selectedSalesBehavior">
                    <sales-behaviors-projects
                        :sales-behaviors-projects="selectedSalesBehavior"
                        :current-order="currentOrder"
                        :state="state"
                        :masks="masks"
                        :filter="filter"
                        :user="user"
                        :fixed-date-range-identifier="fixedDateRangeIdentifier"
                        :custom-fields="customFields"
                        :available-columns="(selectedSalesBehavior.follow_up === 1) ?  availableColumns['Follow Up']: availableColumns[selectedSalesBehavior.name]"
                        :user-ids="userIds"
                        :office-ids="officeIds"
                        :contract-type-ids="contractTypeIds"
                        @order="order"
                        @updateParentState="updateParentState"
                        :customFieldTypeConstants="customFieldTypeConstants"
                        :selects="selects"
                        :users="users"
                        :field-labels="fieldLabels"
                        :is-projects-loading="isProjectsLoading"
                        @fetchUpdatedProjects="fetchUpdatedProjects"
                        @fetchNextProjects="fetchNextProjects"
                        :next-page="nextPage"
                        :has-calendar-access="hasCalendarAccess"
                        :record-detail-field-labels="recordDetailFieldLabels"/>
                </div>
                <div v-else>
                    <h5 v-show="!isBehaviorsLoading && salesBehaviorsProjectsList.length == 0">We could not find any sales behaviors for your dashboard. Please contact your admin to enable some sales behaviors for your dashboard.</h5></div>
            </div>

            <div class="col-md-9" v-if="currentTab === 'sales_statuses' && contactSaleBehaviorCurrentItem === null">

                <div class="table-responsive rounded w-full px-2 remove-overflow-x">
                    <table class="text-left w-full border-collapse table-responsive" id="project_index">
                    <thead class="text-white bg-primary p-3" v-if="selectedSalesStatus.id >= 0">
                        <th colspan="11">
                            <div class="flex justify-center">
                                {{ selectedSalesStatus.code }}
                            </div>
                        </th>
                        <th>
                            <div class="float-right">
                                <a class="cursor-pointer text-white mr-2" @click="exportSalesStatus(selectedSalesStatus)">
                                    <i class="fa fa-share-square-o" aria-hidden="true"></i>
                                </a>
                            </div>
                        </th>
                    </thead>
                    <thead>
                        <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                             <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                :class="salesStatusSort === 'bid_id' ? 'text-teal' : ''"
                                @click="orderProjects('bid_id')">
                                Id
                                <i class="fa fa-xs fa-chevron-down ml-2"
                                    v-if="salesStatusSort === 'bid_id' && salesStatusSortOrder === 'desc'"></i>
                                <i class="fa fa-xs fa-chevron-up ml-2"
                                    v-if="salesStatusSort === 'bid_id' && salesStatusSortOrder === 'asc'"></i>
                            </button>
                        </th>
                        <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                             <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                :class="salesStatusSort === 'project_name' ? 'text-teal' : ''"
                                @click="orderProjects('project_name')">
                                Project Name
                                <i class="fa fa-xs fa-chevron-down ml-2"
                                    v-if="salesStatusSort === 'project_name' && salesStatusSortOrder === 'desc'"></i>
                                <i class="fa fa-xs fa-chevron-up ml-2"
                                    v-if="salesStatusSort === 'project_name' && salesStatusSortOrder === 'asc'"></i>
                            </button>
                        </th>
                        <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                            <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                    :class="salesStatusSort === 'office_name' ? 'text-teal' : ''"
                                    @click="orderProjects('office_name')">
                                {{ getFieldLabel(fieldLabels, 'office') }}
                                <i class="fa fa-xs fa-chevron-down ml-2"
                                   v-if="salesStatusSort === 'office_name' && salesStatusSortOrder === 'desc'"></i>
                                <i class="fa fa-xs fa-chevron-up ml-2"
                                   v-if="salesStatusSort === 'office_name' && salesStatusSortOrder === 'asc'"></i>
                            </button>
                        </th>
                        <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                            <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                    :class="salesStatusSort === 'contract_type_name' ? 'text-teal' : ''"
                                    @click="orderProjects('contract_type_name')">
                                {{ getFieldLabel(fieldLabels, 'contract-type') }}
                                <i class="fa fa-xs fa-chevron-down ml-2"
                                   v-if="salesStatusSort === 'contract_type_name' && salesStatusSortOrder === 'desc'"></i>
                                <i class="fa fa-xs fa-chevron-up ml-2"
                                   v-if="salesStatusSort === 'contract_type_name' && salesStatusSortOrder === 'asc'"></i>
                            </button>
                        </th>
                        <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                            <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                :class="salesStatusSort === 'client' ? 'text-teal' : ''"
                                @click="orderProjects('client')">
                                Company
                                <i class="fa fa-xs fa-chevron-down ml-2"
                                    v-if="salesStatusSort === 'client' && salesStatusSortOrder === 'desc'"></i>
                                <i class="fa fa-xs fa-chevron-up ml-2"
                                    v-if="salesStatusSort === 'client' && salesStatusSortOrder === 'asc'"></i>
                            </button>
                        </th>
                        <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                            <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                :class="salesStatusSort === 'contact' ? 'text-teal' : ''"
                                @click="orderProjects('contact')">
                                Contact
                                <i class="fa fa-xs fa-chevron-down ml-2"
                                    v-if="salesStatusSort === 'contact' && salesStatusSortOrder === 'desc'"></i>
                                <i class="fa fa-xs fa-chevron-up ml-2"
                                    v-if="salesStatusSort === 'contact' && salesStatusSortOrder === 'asc'"></i>
                            </button>
                        </th>
                        <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                            <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                :class="salesStatusSort === 'phone' ? 'text-teal' : ''"
                                @click="orderProjects('phone')">
                                Phone
                                <i class="fa fa-xs fa-chevron-down ml-2"
                                    v-if="salesStatusSort === 'phone' && salesStatusSortOrder === 'desc'"></i>
                                <i class="fa fa-xs fa-chevron-up ml-2"
                                    v-if="salesStatusSort === 'phone' && salesStatusSortOrder === 'asc'"></i>
                            </button>
                        </th>
                        <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                             <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                :class="salesStatusSort === 'base_bid' ? 'text-teal' : ''"
                                @click="orderProjects('base_bid')">
                                 {{ getFieldLabel(recordDetailFieldLabels, 'base-bid') }}
                                <i class="fa fa-xs fa-chevron-down ml-2"
                                    v-if="salesStatusSort === 'base_bid' && salesStatusSortOrder === 'desc'"></i>
                                <i class="fa fa-xs fa-chevron-up ml-2"
                                    v-if="salesStatusSort === 'base_bid' && salesStatusSortOrder === 'asc'"></i>
                            </button>
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="(project, idx) in projects" class="hover:bg-grey-lighter cursor-pointer" :key="idx" @click="goToProject(project)">
                            <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs  sm:table-cell">
                                {{ project.custom_project_id ? project.custom_project_id : project.sequential_team_id }}
                            </td>
                            <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs  sm:table-cell">
                                {{ project.name }}
                            </td>
                            <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs  sm:table-cell">
                                {{ project.office_name }}
                            </td>
                            <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs  sm:table-cell">
                                {{ project.contract_type_name }}
                            </td>
                             <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs  sm:table-cell">
                                {{ project.company_name }}
                            </td>
                            <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs  sm:table-cell">
                                {{ `${project.contact ? project.contact.name : ''}` }}
                            </td>
                            <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs  sm:table-cell">
                                {{ `${(project.contact && project.contact.phone) ? symbols.currency_name == 'Dollars' ? project.contact.phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3') : project.contact.phone.replace(/[^\d]/g, "") : ''}` }}
                            </td>
                            <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs  sm:table-cell">
                                {{ project.base_bid }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
                 <div v-if="pagination.total > pagination.per_page" class="flex justify-center mt-2">
                    <b-pagination
                        @change="(page)=>fetchProjects(selectedSalesStatus, page)"
                        v-model="pagination.current_page"
                        :total-rows="pagination.total"
                        :per-page="pagination.per_page"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                    ></b-pagination>
                </div>
            </div>

            <div class="col-md-9" v-if="contactSaleBehaviorCurrentItem">
                <sales-behaviors-contact
                    :sales-behaviors-contacts="contactSaleBehaviorCurrentItem"
                    :current-order="contactCurrentOrder"
                    :state="contactState"
                    :masks="masks"
                    :filter="filter"
                    :user="user"
                    :fixed-date-range-identifier="fixedDateRangeIdentifier"
                    :contact-custom-fields="contactCustomFields"
                    :available-columns="contactAvailableColumns[contactSaleBehaviorCurrentItem.name]"
                    :user-ids="userIds"
                    :office-ids="officeIds"
                    :contract-type-ids="contractTypeIds"
                    :field-labels="fieldLabels"
                    :contact-custom-field-type-constants="contactCustomFieldTypeConstants"
                    :is-contacts-loading="isContactsLoading"
                    @contactOrder="contactOrder"
                    @fetchNextContacts="fetchNextContacts"
                    :contact-next-page="contactNextPage"
                    @updateContactParentState="updateContactParentState"/>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: ['dateRange', 'user', 'filter', 'state', 'masks', 'fixedDateRangeIdentifier',
        'customFields', 'userIds', 'contractTypeIds', 'officeIds', 'availableColumns','symbols', 'contactAvailableColumns',
        'contactState', 'contactCustomFields','hasCalendarAccess', 'customFieldTypeConstants','fieldLabels', 'contactCustomFieldTypeConstants',
        'recordDetailFieldLabels'],

    data() {
        return {
            currentOrder: {
                property: null,
                direction: null
            },
            contactCurrentOrder: {
                property: null,
                direction: null
            },
            currentTab: 'sales_behaviors',
                followUpsList: [],
            salesBehaviorsProjectsList: [],
            salesStatusesList : [],
            projects: [],
            selectedSalesStatus: {id:0, code: 'All'},
            salesStatusPage: 1,
            pagination : {},
            salesStatusSort: 'bid_id',
            salesStatusSortOrder: 'asc',
            updatedStates: {},
            updatedStatesCount: 0,
            contactUpdatedStates: {},
            contactUpdatedStatesCount: 0,
            newState: this.state,
            salesBehaviorsContactsList: [],
            contactSaleBehaviorCurrentItem: null,
            contactActivityActiveIndex: null,
            selects: {},
            users: [],
            activateSection: true,
            hasSavedState: !!this.state,
            isBehaviorsLoading: true,
            isSalesStatusLoading: true,
            isContactBehaviorsLoading: true,
            selectedSalesBehavior: null,
            isProjectsLoading: true,
            nextPage: null,
            isContactsLoading: true,
            contactNextPage: null,
        }
    },

    created() {
        let currentUrl = window.location.href;
        if(currentUrl.search('#sl-') !== -1){
            this.activateSection = false;
        }

        this.currentOrder.property = localStorage.hasOwnProperty('dashboard.property') ? localStorage.getItem('dashboard.property') : 'meeting_date';
        this.currentOrder.direction = localStorage.hasOwnProperty('dashboard.direction') ? localStorage.getItem('dashboard.direction') : 'asc';
        this.contactCurrentOrder.property = localStorage.hasOwnProperty('dashboard.contactProperty') ? localStorage.getItem('dashboard.contactProperty') : 'meeting_date';
        this.contactCurrentOrder.direction = localStorage.hasOwnProperty('dashboard.contactDirection') ? localStorage.getItem('dashboard.contactDirection') : 'asc';
        this.currentTab = localStorage.hasOwnProperty('currentTab') ? localStorage.getItem('currentTab') : 'sales_behaviors';

        if(this.currentTab  && this.currentTab === 'sales_statuses') {
            this.fetchSalesStatuses();
        }else{
            this.fetchSalesBehaviors();
        }
        this.fetchContactSalesBehaviors();
        this.fetchCodes();
        this.fetchTeamUsers();
    },

    mounted() {
    },

    methods: {
        updateParentState (updatedState) {
            const salesBehaviors = Object.keys(updatedState)
            salesBehaviors.map((key) => {
                this.updatedStates[key] = updatedState[key]
            })
            // this.updatedStatesCount = this.updatedStatesCount+1
            // if(this.updatedStatesCount > this.salesBehaviorsProjectsList.length || (!this.hasSavedState && this.updatedStatesCount === this.salesBehaviorsProjectsList.length)) {
            //     this.hasSavedState = true;
                axios.put(route('api.dashboard.state'), { state: this.updatedStates })
                    .then(response => {

                    });
            // }
        },
        updateContactParentState (updatedState) {
            const salesBehaviors = Object.keys(updatedState)
            salesBehaviors.map((key) => {
                this.contactUpdatedStates[key] = updatedState[key]
            })
            this.contactUpdatedStatesCount = this.contactUpdatedStatesCount+1
            axios.put(route('api.dashboard.state.contact'), { state: this.contactUpdatedStates })
                .then(response => {

                });
        },
        order(property) {
            if (this.currentOrder.property === property) {
                this.currentOrder.direction = this.currentOrder.direction === 'asc' ? 'desc' : 'asc';
            } else if (property === 'age') {
                this.currentOrder.direction = 'desc';
            } else if (this.currentOrder.property === null || this.currentOrder.property !== property) {
                this.currentOrder.property = property;
                this.currentOrder.direction = 'asc';
            }

            localStorage.setItem('dashboard.property', this.currentOrder.property);
            localStorage.setItem('dashboard.direction', this.currentOrder.direction);

            this.currentOrder.property = property;
            this.fetchProjectsBySalesBehaviors();
        },
        contactOrder(property) {
            if (this.contactCurrentOrder.property === property) {
                this.contactCurrentOrder.direction = this.contactCurrentOrder.direction === 'asc' ? 'desc' : 'asc';
            } else if (property === 'age') {
                this.contactCurrentOrder.direction = 'desc';
            } else if (this.contactCurrentOrder.property === null || this.contactCurrentOrder.property !== property) {
                this.contactCurrentOrder.property = property;
                this.contactCurrentOrder.direction = 'asc';
            }

            localStorage.setItem('dashboard.contactProperty', this.contactCurrentOrder.property);
            localStorage.setItem('dashboard.contactDirection', this.contactCurrentOrder.direction);

            this.contactCurrentOrder.property = property;
            this.fetchContactsBySalesBehaviors();
        },
        orderBoth(followUpName, salesBehaviorName) {
            if (this.followUpsList)
                this.orderFollowUps(followUpName);
            this.orderSalesBehaviorsProjects(salesBehaviorName);
        },
        contactOrderBoth(followUpName, salesBehaviorName) {
            this.orderSalesBehaviorsContacts(salesBehaviorName);
        },
        orderProjects(property){
            this.salesStatusSort = property;
            this.salesStatusSortOrder = this.salesStatusSortOrder === 'desc' ? 'asc' : 'desc';

            this.fetchProjects(this.selectedSalesStatus, 1);
        },
        fetchProjects(salesStatus, page){

            this.selectedSalesStatus = salesStatus;

            let params  = {
                user_ids:            (this.userIds != null && this.userIds.length > 0)? this.userIds : [this.user.id],
                from:               this.dateRange.start,
                to:                 this.dateRange.end,
                sales_status_id:    salesStatus.id,
                page:               page,
                sortBy:             this.salesStatusSort,
                sortOrder:          this.salesStatusSortOrder,
                filter:             this.filter,
                office_ids:          this.officeIds,
                contract_type_ids:    this.contractTypeIds,
            };

            axios.get(route('api.projects-by-salesStatus.dashboard'), {params})
                .then(({data}) => {
                this.projects           = data.data;
                this.pagination         = data.meta;
                this.data_loading       = false;
            });
        },
        goToProject(project){
            window.location = route('project.edit', {project: project.id}) + `?dashboard=1`;
        },
        exportSalesStatus(salesStatus){
            window.location = route('reports-charts.dashboard-sales-statuses-excel',
                                {
                                    user            : this.user.id,
                                    sales_status_id : this.selectedSalesStatus.id,
                                    'start-date'    : this.dateRange.start,
                                    'end-date'      : this.dateRange.end,
                                    'name'          : 'sales-status-dashboard'
                                }
                            );
        },
        orderFollowUps(property) {
            this.followUpsList.projects = _.orderBy(this.followUpsList.projects, ['pin_project', p => {

                switch (property) {
                    case 'sequential_team_id':
                        return p.sequential_team_id != '-' ? Number(p.sequential_team_id) : '-';
                        break;
                    case 'project_name':
                        return p.project_name != '-' ? p.project_name : '-';
                        break;
                    case 'status':
                        return p.status != '-' ? p.status : '-';
                        break;
                    case 'base_bid':
                        // return Number(p.base_bid != '-' ? p.base_bid.replace(/\$|,| /g, '') : 0);
                        return p.base_bid;
                        break;
                    case 'contract_amount':
                        // return Number(p.contract_amount != '-' ? p.contract_amount.replace(/\$|,| /g, '') : 0);
                        return p.contract_amount;
                        break;
                    case 'gross_margin':
                        // return Number(p.gross_margin != '-' ? p.gross_margin.replace(/\%|,| /g, '') : 0);
                        return p.gross_margin;
                        break;
                    case 'contract_date':
                        return moment(p.contract_date, this.masks.moment_mask).format('YYYYMMDD');
                        break;
                    case 'login_date':
                        return moment(p.login_date, this.masks.moment_mask).format('YYYYMMDD');
                        break;
                    case 'pre_bid':
                        return moment(p.pre_bid, this.masks.moment_mask).format('YYYYMMDD');
                        break;
                    case 'bid_date':
                        return moment(p.bid_date, this.masks.moment_mask).format('YYYYMMDD');
                        break;
                    case 'dead_date':
                        return moment(p.dead_date, this.masks.moment_mask).format('YYYYMMDD');
                        break;
                    case 'company_contact_followup':
                        return moment(p.company_contact_followup, this.masks.moment_mask).format('YYYYMMDD');
                        break;
                    case 'age':
                        return p.age;
                        break;
                    case 'project_contact_phone':
                        return p.project_contact_phone ? p.project_contact_phone.replace(/\D/g, '') : p.project_contact_phone;
                        break;
                    case 'project_contact_cell':
                        return p.project_contact_cell ? p.project_contact_cell.replace(/\D/g, '') : p.project_contact_cell;
                        break;
                    case 'project_contact_fax':
                        return p.project_contact_fax ? p.project_contact_fax.replace(/\D/g, '') : p.project_contact_fax;
                        break;
                    case 'company_contact_cell':
                        return p.company_contact_cell ? p.company_contact_cell.replace(/\D/g, '') : p.company_contact_cell;
                        break;
                    case 'meeting_date':
                        return p.meeting_date;
                        break;
                    default:
                        return p[property] ? ((p[property] != '' && p[property] != "") ? p[property] : '-') : '-';

                }
            }], ['desc', this.currentOrder.direction]);
        },
        orderSalesBehaviorsProjects(property) {
            _.forEach(this.salesBehaviorsProjectsList, (item, index) => {
                if(!item.is_followup){
                    this.salesBehaviorsProjectsList[index].data.projects = _.orderBy(this.salesBehaviorsProjectsList[index].data.projects, ['pin_project', p => {
                    switch (property) {
                        case 'sequential_team_id':
                            return p.sequential_team_id != '-' ? Number(p.sequential_team_id) : '-';
                            break;
                        case 'project_name':
                            return p.project_name != '-' ? p.project_name : '-';
                            break;
                        case 'status':
                            return (p.status != '-' && p.status != null) ? p.status : '-';
                            break;
                        case 'base_bid':
                            // return Number((p.base_bid != '-' && p.base_bid != null) ? p.base_bid.replace(/\$|,| /g, '') : 0);
                            return p.base_bid;
                            break;
                        case 'contract_amount':
                            // return Number((p.contract_amount != '-' && p.contract_amount != null) ? p.contract_amount.replace(/\$|,| /g, '') : 0);
                            return p.contract_amount;
                            break;
                        case 'gross_margin':
                            // return Number(p.gross_margin != '-' ? p.gross_margin.replace(/\%|,| /g, '') : 0);
                            return p.gross_margin;
                            break;
                        case 'contract_date':
                            return moment(p.contract_date, this.masks.moment_mask).format('YYYYMMDD');
                            break;
                        case 'login_date':
                            return moment(p.login_date, this.masks.moment_mask).format('YYYYMMDD');
                            break;
                        case 'pre_bid':
                            return moment(p.pre_bid, this.masks.moment_mask).format('YYYYMMDD');
                            break;
                        case 'bid_date':
                            return moment(p.bid_date, this.masks.moment_mask).format('YYYYMMDD');
                            break;
                        case 'dead_date':
                            return moment(p.dead_date, this.masks.moment_mask).format('YYYYMMDD');
                            break;
                        case 'company_contact_followup':
                            return (p.company_contact_followup != null) ? moment(p.company_contact_followup, this.masks.moment_mask).format('YYYYMMDD'): null;
                            break;
                        case 'age':
                            return p.age;
                            break;
                        case 'project_contact_phone':
                            return p.project_contact_phone ? p.project_contact_phone.replace(/\D/g, '') : p.project_contact_phone;
                            break;
                        case 'project_contact_cell':
                            return p.project_contact_cell ? p.project_contact_cell.replace(/\D/g, '') : p.project_contact_cell;
                            break;
                        case 'project_contact_fax':
                            return p.project_contact_fax ? p.project_contact_fax.replace(/\D/g, '') : p.project_contact_fax;
                            break;
                        case 'company_contact_cell':
                            return p.company_contact_cell ? p.company_contact_cell.replace(/\D/g, '') : p.company_contact_cell;
                            break;
                        case 'meeting_date':
                            return p.meeting_date;
                            break;
                        default:
                            return p[property] ? ((p[property] != '' && p[property] != "") ? p[property] : '-') : '-';
                    }
                }], ['desc', this.currentOrder.direction]);
                }
            });
        },
        orderSalesBehaviorsContacts(property) {
            _.forEach(this.salesBehaviorsContactsList, (item, index) => {
                this.salesBehaviorsContactsList[index].data.contacts = _.orderBy(this.salesBehaviorsContactsList[index].data.contacts, p => {
                    switch (property) {
                        case 'id':
                            return p.id != '-' ? Number(p.id) : '-';
                            break;
                        case 'name':
                            return p.name != '-' ? p.name : '-';
                            break;
                        case 'contact_type_name':
                            return p.contact_type_name != '-' ? p.contact_type_name : '-';
                            break;
                        case 'company_name':
                            return p.company_name != '-' ? p.company_name : '-';
                            break;
                        case 'email':
                            return p.email;
                            break;
                        case 'title':
                            return p.title;
                            break;
                        case 'age':
                            return p.age;
                            break;
                        case 'cell':
                            return p.cell ? p.cell.replace(/\D/g, '') : p.cell;
                            break;
                        case 'meeting_date':
                            return moment(p.meeting_date, this.masks.moment_mask).format('YYYYMMDD');
                            break;
                        default:
                            return p[property]
                    }
                }, this.contactCurrentOrder.direction);
            });
        },
        changeTab(currentTab) {
            this.currentTab = currentTab;
            localStorage.setItem('currentTab', currentTab);
            if(currentTab === 'sales_statuses' && this.salesStatusesList.length === 0){
                this.fetchSalesStatuses()
            }else if(currentTab === 'sales_behaviors' && this.salesBehaviorsProjectsList.length === 0){
                this.fetchSalesBehaviors()
            }
            this.activateSelectedTab();
            this.changeContactActivitiesTab(null);
            this.removeActiveContactActivity();
        },
        changeContactActivitiesTab(item) {

            this.contactSaleBehaviorCurrentItem = item;
            if(item && this.contactSaleBehaviorCurrentItem){
                this.fetchContactsBySalesBehaviors();
            }
        },
        removeActiveContactActivity() {
            this.$nextTick(() => {
                $('.saleBehaviorTabListAnchor').removeClass('active');
                $('.saleBehaviorTabListAnchorTabPanel').removeClass('active');
            });
            this.contactActivityActiveIndex = null;
        },
        setActiveContactActivity(index) {

            this.contactActivityActiveIndex = index;
            const elList = document.querySelectorAll('.saleBehaviorTabListAnchor');
            elList.forEach(el => el.classList.remove("active"));
            const elList1 = document.querySelectorAll('.saleStatusTabListAnchor');
            elList1.forEach(el => el.classList.remove("text-primary"));
        },
        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = data;
            });
        },
        fetchTeamUsers() {
            axios.get(route('api.team-users')).then(({data}) => {
                this.users = data;
            })
        },
        fetchUpdatedProjects() {
            window.location.reload();
        },
        fetchSalesBehaviors() {
            let params  = {
                user_ids:            (this.userIds != null && this.userIds.length > 0)? this.userIds : [this.user.id],
                from:               this.dateRange.start,
                to:                 this.dateRange.end,
                filter:             this.filter,
                office_ids:          this.officeIds,
                contract_type_ids:    this.contractTypeIds,
                timeZoneDiff:             moment().format("Z"),
            };
            axios.get(route('api.dashboard.sales-behaviors'), {params})
                .then(({data}) => {
                    this.salesBehaviorsProjectsList = data
                    this.isBehaviorsLoading = false;
                    this.activateSelectedTab();
                });
        },
        fetchSalesStatuses() {
            let params  = {
                user_ids:            (this.userIds != null && this.userIds.length > 0)? this.userIds : [this.user.id],
                from:               this.dateRange.start,
                to:                 this.dateRange.end,
                filter:             this.filter,
                office_ids:          this.officeIds,
                contract_type_ids:    this.contractTypeIds,
                timeZoneDiff:             moment().format("Z"),
            };
            axios.get(route('api.dashboard.sales-statuses'), {params})
                .then(({data}) => {
                    this.salesStatusesList = data
                    this.isSalesStatusLoading = false;
                    if(this.selectedSalesStatus) {
                        this.fetchProjects(this.selectedSalesStatus, 1)
                    }
                });
        },
        fetchContactSalesBehaviors() {
            let params  = {
                user_ids:            (this.userIds != null && this.userIds.length > 0)? this.userIds : [this.user.id],
                from:               this.dateRange.start,
                to:                 this.dateRange.end,
                filter:             this.filter,
                office_ids:          this.officeIds,
                contract_type_ids:    this.contractTypeIds,
                timeZoneDiff:             moment().format("Z"),
            };
            axios.get(route('api.dashboard.contact-sales-behaviors'), {params})
                .then(({data}) => {
                    this.salesBehaviorsContactsList = data;
                    this.isContactBehaviorsLoading = false
                });
        },
        selectSalesBehavior(item) {
            location.href = '#sl-'+item.id
            this.selectedSalesBehavior = item
            this.isProjectsLoading = true;
            this.fetchProjectsBySalesBehaviors();
        },
        activateSelectedTab() {
            this.$nextTick(() => {
                if(!this.selectedSalesBehavior) {
                    if (location.hash !== '') {
                        this.selectedSalesBehavior = this.salesBehaviorsProjectsList.find(x => x.id === parseInt(location.hash.replace('#sl-', '')));
                    }else{
                        this.selectedSalesBehavior = this.salesBehaviorsProjectsList.length > 0 ? this.salesBehaviorsProjectsList[0] : null;
                    }
                }
                if(this.selectedSalesBehavior.data.projects.length  == 0) {
                    this.fetchProjectsBySalesBehaviors();
                }
            })
        },
        fetchProjectsBySalesBehaviors(page = 1) {

            this.isProjectsLoading = true;
            let params  = {
                user_ids:            (this.userIds != null && this.userIds.length > 0)? this.userIds : [this.user.id],
                from:               this.dateRange.start,
                to:                 this.dateRange.end,
                office_ids:          this.officeIds,
                contract_type_ids:    this.contractTypeIds,
                sales_behavior_id:    this.selectedSalesBehavior.id,
                page:               page,
                sortBy:             this.currentOrder.property,
                sortDirection:             this.currentOrder.direction,
                timeZoneDiff:             moment().format("Z"),
                columns: this.selectedSalesBehavior.follow_up ? this.availableColumns['Follow Up'].map(column => (column.property_name)) : this.availableColumns[this.selectedSalesBehavior.name].map(column => (column.property_name)),
            };

            axios.post(route('api.dashboard.projects-by-sales-behavior'), params)
                .then(({data}) => {
                    if(data.sales_behavior_id == this.selectedSalesBehavior.id) {
                        if(data.current_page == 1) {
                            this.selectedSalesBehavior.data.projects = data.projects;
                        }else{
                            this.selectedSalesBehavior.data.projects = [...this.selectedSalesBehavior.data.projects, ...data.projects];
                        }
                        if(data.last_page > data.current_page) {
                            this.nextPage = page+1;
                        }else{
                            this.nextPage = null;
                        }
                        this.isProjectsLoading = false;
                    }
                });
        },
        fetchNextProjects(data) {
            this.fetchProjectsBySalesBehaviors(data.page);
        },
        fetchContactsBySalesBehaviors(page = 1) {
            this.isContactsLoading = true;
            let params  = {
                user_ids:            (this.userIds != null && this.userIds.length > 0)? this.userIds : [this.user.id],
                from:               this.dateRange.start,
                to:                 this.dateRange.end,
                office_ids:          this.officeIds,
                contract_type_ids:    this.contractTypeIds,
                sales_behavior_id:    this.contactSaleBehaviorCurrentItem.id,
                page:               page,
                sortBy:             this.contactCurrentOrder.property,
                sortDirection:             this.contactCurrentOrder.direction,
            };

            axios.post(route('api.dashboard.contacts-by-sales-behavior'), params)
                .then(({data}) => {
                    if(data.sales_behavior_id == this.contactSaleBehaviorCurrentItem.id) {
                        if(data.current_page == 1) {
                            this.contactSaleBehaviorCurrentItem.data.contacts = data.contacts;
                        }else{
                            let contacts = data.contacts;
                            if(typeof data.contacts == 'object') {
                                contacts = Object.values(data.contacts)
                            }
                            this.contactSaleBehaviorCurrentItem.data.contacts = [...this.contactSaleBehaviorCurrentItem.data.contacts, ...contacts];
                        }
                        if(data.last_page > data.current_page) {
                            this.contactNextPage = page+1;
                        }else{
                            this.contactNextPage = null;
                        }
                        this.isContactsLoading = false;
                    }
                });
        },
        fetchNextContacts(data) {
            this.fetchContactsBySalesBehaviors(data.page);
        },
    }
}
</script>

<style scoped>
    .active{
        color: #38b1af;
    }
</style>

<style>
    .red-indicator {
        border-radius: 9999px;
        min-width: 42px;
        max-width: 25px;
        max-height: 25px;
        background-color: #F00;
    }
    .black-indicator{
        border-radius: 9999px;
        min-width: 56px;
        max-width: 40px;
        max-height: 40px;
    }

</style>
